  import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody
  } from '@chakra-ui/react';
  import CustomChakraButton from '../../../CustomChakraButton/CustomChakraButton';

  interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
  }

  export const ConfirmCancelingPaymentPopup = ({ isOpen, onClose, onConfirm }: Props) => {
    return (
      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay
          sx={{
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }}
        />
        <ModalContent>
          <ModalHeader className="flex flex-col gap-spacing-xl">
            <h2 className="font-semibold text-lg text-grayLight-900">Wycofanie stawek</h2>
            <div className="font-normal text-sm text-grayLight-900">
              Salda konsumentów powiązanych z płatnością zostaną pomniejszone o wartość wpłaty.
            </div>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="grid gap-spacing-3xl">
            <div className="w-full flex justify-end gap-4 p-4">
              <CustomChakraButton
                hierarchy="secondaryColor"
                size="sm"
                iconPosition="onlyText"
                buttonProps={{
                  type: 'button',
                  onClick: () => onClose()
                }}>
                Wróć
              </CustomChakraButton>
              <CustomChakraButton
                hierarchy="primary"
                size="sm"
                iconPosition="onlyText"
                buttonProps={{
                  type: 'button',
                  onClick: () => {
                    onConfirm();
                  }
                }}>
                Wycofaj płatność
              </CustomChakraButton>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  };
